export const DEFAULT_NUMBER = '-';

export const SLIGHTLY_LARGER_FONT = { fontSize: '1.1rem' };
export const CPR_HEIGHT = { fontSize: '1.7rem' };
